/**
 * The scopes the console asks Zitadel for (`docs/architecture/auth-zitadel.md` §16).
 *
 * The project's audience scope is what makes the access token one the services accept; the
 * resource owner names the person's home organization; `offline_access` brings the refresh token
 * the session renews with. No organization hint: one address serves every school, so the sign-in
 * page wears Rythmo's branding and the school is chosen after.
 */
export function scopesFor(projectId: string): string {
  return [
    'openid',
    'profile',
    'email',
    'offline_access',
    'urn:zitadel:iam:user:resourceowner',
    `urn:zitadel:iam:org:project:id:${projectId}:aud`,
  ].join(' ');
}
